import { validateField as validateBasicField } from "@am/multi_step_forms/validation";

export function validateFascinatingFindsField(
  fieldId,
  fieldConfig,
  value,
  values,
  filesState,
) {
  if (fieldId === "photos") {
    const photos = filesState.photos || [];
    if (photos.length < 3 || photos.length > 5)
      return "Please upload between 3 and 5 images.";
    for (const photo of photos) {
      if (
        !(photo.copyrightText || "").trim() ||
        !(photo.photographer || "").trim()
      ) {
        return "Please add copyright text and photographer for each photo.";
      }
    }
    return null;
  }
  if (
    fieldId === "postcode" &&
    value &&
    !/^\d{4}$/.test(String(value).trim())
  ) {
    return "Postcode must be exactly 4 digits.";
  }
  return validateBasicField(fieldId, fieldConfig, value, values, filesState);
}
